import React from 'react';
import PropTypes from 'prop-types';
import { FormContext } from './FormHooks';

const formPropTypes = {
	value: PropTypes.exact({
		formState: PropTypes.func,
		formUpdate: PropTypes.func,
		formRegistry: PropTypes.func,
	}).isRequired,
	children: PropTypes.element.isRequired,
};

const formDefaultProps = {};

const FormStateProvider = ({ value, children }) => {
	return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

FormStateProvider.propTypes = formPropTypes;
FormStateProvider.defaultProps = formDefaultProps;

export default FormStateProvider;
